import { businessKey } from 'queryKeys';

export const NEWS = 'news';
export const TYPES = 'types';
const newsQuery = businessKey.query(NEWS);

export const grids = newsQuery.grids();
export const grid = newsQuery.grid();

export const types = newsQuery.exact(TYPES);

export const details = newsQuery.details();
export const model = newsQuery.exact();

export const mutations = newsQuery.mutations();

export const create = mutations.create();
export const update = mutations.update();
export const remove = mutations.delete();

// Release
export const RELEASE = 'release';
export const release = businessKey.query(RELEASE);

const MUTATION_UPDATE_RELEASE_DATA = 'remove';

export const releaseMutations = newsQuery.mutations(RELEASE);
export const updateReleaseDate = releaseMutations.mutate(
  MUTATION_UPDATE_RELEASE_DATA
);
